import { render, staticRenderFns } from "./TitleSlicerBarIcon.vue?vue&type=template&id=3ec929c3&scoped=true"
import script from "./TitleSlicerBarIcon.vue?vue&type=script&lang=js"
export * from "./TitleSlicerBarIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec929c3",
  null
  
)

export default component.exports